import Sortable, { MultiDrag } from "sortablejs";

class MultiDragPluginExtension {
  static pluginName = "MultiDragPluginExtension";

  constructor(private sortable: Sortable) {}

  delayStartGlobal(event: { dragEl: HTMLElement }) {
    const selectElement = (el: HTMLElement, select = true) =>
      select ? Sortable.utils.select(el) : Sortable.utils.deselect(el);

    const deselectMultiDragItems = () => {
      // deselect all items
      if ("multiDrag" in this.sortable && this.sortable.multiDrag) {
        const multiDrag = this.sortable.multiDrag as {
          _deselectMultiDrag: () => void;
        };
        multiDrag._deselectMultiDrag();
        return true;
      }
      return false;
    };

    // Add custom onBeforeStart, to allow selecting rows using Sortable.select before MultiDrag Kicks in
    if (
      this.sortable.options.multiDrag &&
      "onBeforeStart" in this.sortable.options &&
      typeof this.sortable.options.onBeforeStart === "function"
    ) {
      this.sortable.options.onBeforeStart({ ...event, deselectMultiDragItems, selectElement });
    }
  }
}

export function mountSortablePlugins() {
  // MultiDrag does not work on test environment
  if (import.meta.env.VITEST) return;
  Sortable.mount(MultiDragPluginExtension);
  Sortable.mount(new MultiDrag());
}
